import m from "mithril";
import "./style.scss";
import { LoginPage } from "./login-page";
import { initFirebase } from "./firebase";
import { DownloadPage } from "./download-page";

initFirebase();
const root = document.getElementById("root");
m.route(root, "/login", {
  "/login": LoginPage,
  "/download": DownloadPage,
});